<template>
  <b-card class="text-center">

    <!-- apex chart -->
    <vue-apex-charts
      type="treemap"
      :height="boxHeight-120"
      :options="chartOptions"
      :series="series"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'

import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    VueApexCharts,
    BCard,
  },
  props: {
    showBase: {
      type: Boolean,
      default: false,
    },
    percentage: {
      type: String,
      default: null,
    },
    boxHeight: {
      type: [Number, String],
      default: 350,
    },
    seriesData: {
      type: [Array, Object],
      default: null,
    },
    colorSteps: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      series: [
        {
          data: [],
        },
      ],
    }
  },
  computed: {
    chartOptions() {
      const vueThis = this
      return {
        chart: {
          type: 'treemap',
          toolbar: {
            show: false,
          },
        },

        dataLabels: {
          enabled: true,
          style: {
            fontSize: '12px',
          },
          formatter(text, op) {
            return [`${text}`, `${vueThis.percentage} ${op.value}`, (vueThis.showBase ? `n:${op.w.config.series[0].data[op.dataPointIndex].base}` : '')]
          },
          offsetY: -4,
        },
        tooltip: {
          y: {
            formatter(text, op) {
              return `${vueThis.percentage} ${text} ${vueThis.showBase ? `(n:${op.w.config.series[0].data[op.dataPointIndex].base})` : ''}`
            },
          },
        },
        plotOptions: {
          treemap: {
            enableShades: true,
            shadeIntensity: 0.5,
            reverseNegativeShade: true,
            colorScale: {
              ranges: this.colorSteps,
            },
          },
        },

      }
    },
  },
  watch: {
    seriesData() {
      this.initData()
    },
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.series = [{ data: [] }]
      this.series[0].data = this.seriesData[0].data.map(d => ({ x: d.name, y: d.y, base: d.base }))
    },
  },
}

</script>
